/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_ADDNEWUSERGENPOOL,ADDNEWUSERGENPOOL_RECEIVED } = constants.AddNewUserGenPoolConstants;

export default {
    REQUEST_ADDNEWUSERGENPOOL,
    ADDNEWUSERGENPOOL_RECEIVED,

  requestAddNewUserGenPool: payload => ({
    type: REQUEST_ADDNEWUSERGENPOOL,
    payload
  }),
  AddNewUserGenPoolReceived: () => ({
    type: ADDNEWUSERGENPOOL_RECEIVED
  }),
};
